import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './Login/Login';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Login />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js